export * from './skill-icon.pipe';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/skill-icon.pipe/index.ts